import React, { useState, useEffect, useRef } from "react";
import { IBreadcrumbsProps, Breadcrumb } from "./breadcrumbs.props";
import FaIcon from "../fa-icon/fa-icon";
import IconEnum from "../../enums/icon.enum";
import SizeEnum from "../../enums/size.enum";
import "./breadcrumbs.scss";

const Breadcrumbs = (props: IBreadcrumbsProps) => {
  const { crumbs, mpngStyle } = props;
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setShowDropdown(false); // Close dropdown when crumbs change
  }, [crumbs]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | FocusEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("focusin", handleClickOutside); // for keyboard navigation
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("focusin", handleClickOutside); // for keyboard navigation
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("focusin", handleClickOutside); // for keyboard navigation
    };
  }, [showDropdown, dropdownRef]);

  return (
    <div className={`${mpngStyle ? "mpng-style" : ""} breadcrumbs-container`} data-testid="breadcrumbs-container">
      {crumbs.map((breadcrumb: Breadcrumb, index: number) => {
        if (index < 3) {
          return (
            <div key={breadcrumb.name} className="breadcrumb-container">
              <button key={breadcrumb.name} onClick={() => breadcrumb.callback()} className="breadcrumb-name">
                {breadcrumb.name}
              </button>
              {index !== crumbs.length - 1 && index < 2 && (
                <FaIcon className="breadcrumb-separator" icon={IconEnum.CHEVRON_RIGHT} />
              )}
            </div>
          );
        }
      })}
      {crumbs.length > 3 && (
        <div ref={dropdownRef} className="breadcrumb-dropdown-container">
          <button
            className="breadcrumb-dropdown-toggle"
            data-testid="breadcrumb-dropdown-toggle"
            onClick={() => setShowDropdown((prev) => !prev)}
          >
            <FaIcon className="breadcrumb-dropdown-icon" icon={IconEnum.CHEVRON_DOWN} size={SizeEnum.SMALL} />
          </button>
          {showDropdown && (
            <div className="breadcrumb-dropdown-menu">
              {crumbs.slice(3).map((breadcrumb: Breadcrumb) => (
                <button
                  key={breadcrumb.name}
                  onClick={() => breadcrumb.callback()}
                  className="breadcrumb-dropdown-name"
                >
                  {breadcrumb.name}
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default Breadcrumbs;
